

const Employee = {
  namespaced: true,
  state: {
    sessionEmployees: []
  },
  mutations: {
    setSessionEmployees(state, employee) {
      state.sessionEmployees = employee || []
    },
  },
  actions: {

  },
  getters: {
    getByProjectId: (state) => (id) => {
      const sessionEmployees = state.sessionEmployees || []
      return sessionEmployees.filter(employee => employee.project.objectId === id)
    },
    getByMarketId: (state) => (id) => {
      const sessionEmployees = state.sessionEmployees || []
      return sessionEmployees.find(employee => employee && employee.market && employee.market.objectId === id)
    },
  },
};
export default Employee;
